export default Object.freeze({
    REQUESTED: 'requested',
    PROCESSING: 'processing',
    PENDING: 'pending',
    RETURNED: 'returned',
    REJECTED: 'rejected',
    APPROVED: 'approved',
    
  })